import { FC } from 'react';
import { Box, withStyles, Card, Icon, CircleButton } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Title, Button } from 'UI';

import styles from './LinkDialog.module.scss';

const cn = withStyles(styles);

type LinkDialogProps = {
  link: string;
  onClose: () => void;
};

const LinkDialog: FC<LinkDialogProps> = ({ link, onClose }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Customers.CportalTab.LinkDialog' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global.Buttons' });
  const copyLink = (text: string) => navigator.clipboard.writeText(text);

  return (
    <Card className={cn('card')}>
      <Box flx="col" gapSize="16px" height="auto" ai="center" width="100%">
        <div className={cn('iconContainer')}>
          <Icon icon="sendGradient" width="48px" height="42px" color="none" />
        </div>
        <Box flx="col" gapSize="24px" width="100%">
          <Box flx="col" gapSize="6px" ai="center">
            <Title level="3">{t('title', { defaultValue: 'cPortal Link' })}</Title>
            <div className={cn('description')}>
              {t('description', {
                defaultValue: 'You can share this link with the client so they can log in to cPortal.',
              })}
            </div>
          </Box>
          <div className={cn('linkContainer')}>
            <div className={cn('link')}>{link}</div>
            <CircleButton
              icon="content_copy"
              colorScheme="action"
              className={cn('copyButton')}
              onClick={() => {
                copyLink(link);
              }}
            />
          </div>
          <Box gapSize="12px">
            <Button
              iconLeft="content_copy"
              className={cn('button')}
              size="small"
              onClick={() => {
                copyLink(link);
              }}
            >
              {tGlobal('copyLink', { defaultValue: 'Copy Link' })}
            </Button>
            <Button onClick={onClose} colorScheme="primary" className={cn('button')} size="small">
              {tGlobal('done', { defaultValue: 'Done' })}
            </Button>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default LinkDialog;
